/**
 * Party list (customer/supplier) balance display.
 * Newer list APIs attach `balance` + `invoice_due_total`. Older APIs omit them; in that case we
 * merge `total_due` from account customer-summary / supplier-summary so the list matches reports.
 */

export function partyRowHasServerBalanceFields(record) {
  if (!record || typeof record !== "object") return false;
  return (
    Object.prototype.hasOwnProperty.call(record, "balance") ||
    Object.prototype.hasOwnProperty.call(record, "invoice_due_total")
  );
}

/**
 * @param {object} record - customer or supplier row
 * @param {Map<number, number>|null|undefined} summaryDueById - id -> total_due from summary API
 */
export function getPartyListBalance(record, summaryDueById) {
  const opening = Number(record?.opening_balance ?? 0);
  const openingSafe = Number.isFinite(opening) ? opening : 0;

  if (partyRowHasServerBalanceFields(record)) {
    if (record.balance != null && record.balance !== "") {
      const b = Number(record.balance);
      return Number.isFinite(b) ? Math.round(b * 100) / 100 : 0;
    }
    const inv = Number(record.invoice_due_total ?? 0);
    const invSafe = Number.isFinite(inv) ? inv : 0;
    return Math.round((openingSafe + invSafe) * 100) / 100;
  }

  const id = Number(record?.id);
  let invDue = 0;
  if (summaryDueById && Number.isFinite(id)) {
    const raw = summaryDueById.get(id);
    if (raw != null) {
      const n = Number(raw);
      invDue = Number.isFinite(n) ? n : 0;
    }
  }
  return Math.round((openingSafe + invDue) * 100) / 100;
}
